import api from '@/helpers/api';
import StatusTypes from '../../../helpers/enums/statusTypes.enum';

export default {
  fetchInstantReplyList({ commit, rootState }, merchantId) {
    commit('START_LOADING_INSTANT_REPLIES');
    api('GET', `organisation/${rootState.organisation.currentOrganisation.id}/business/${merchantId}/instant-replies/list`, null, null, 'w')
      .then((response) => {
        if (response.status === 200) {
          commit('SET_INSTANT_REPLIES_LIST', response.data);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },
  fetchInstantReply({ commit, rootState }, data) {
    api('GET', `/w/organisation/${rootState.organisation.currentOrganisation.id}/business/${data.businessId}/instant-replies/${data.replyId}`, null, null, 'w')
      .then((response) => {
        if (response.status === 200) {
          commit('SET_INSTANT_REPLY', response.data);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },
  // fetchInstantReplyBatch({ commit, rootState }, data) {
  //   api('GET', `/w/organisation/${rootState.organisation.currentOrganisation.id}/business/${data.business_uid}/instant-replies/list`, {}, null, 'w')
  //     .then((response) => {
  //       if (response.status === 200) {
  //         commit('SET_INSTANT_REPLY', response.data);
  //       }
  //     })
  //     .catch((error) => {
  //       commit('API_ERROR', error.response);
  //     });
  // },
  setInstantReplyOrder({ rootState }, payload) {
    const request = api('PUT', `organisation/${rootState.organisation.currentOrganisation.id}/business/${payload.merchant_id}/instant-replies/order`, payload.data, null, 'w');
    return request;
  },
  createInstantReply({ commit, rootState }, payload) {
    commit('INSTANT_REPLY_SAVED', false);
    const request = api('POST', `organisation/${rootState.organisation.currentOrganisation.id}/business/${payload.merchant_id}/instant-replies`, payload.data, null, 'w');
    request
      .then((response) => {
        if (response.status === 200) {
          commit('INSTANT_REPLY_SAVED', {
            reply_id: response.data.instant_reply.id,
            temp_id: payload.temp_id,
          });
        }
      })
      .catch((error) => {
        commit('API_ERROR', {
          error: error.response,
          reply_id: payload.temp_id,
        });
      });

    return request;
  },
  updateInstantReply({ commit, rootState }, payload) {
    commit('INSTANT_REPLY_SAVED', false);

    if (payload.data && payload.data.messages) {
      payload.data.messages.forEach((message) => {
        message.text = message.text.replaceAll('{{contact name}}', '{{contact_name}}');
        message.text = message.text.replaceAll('{{number name}}', '{{business_name}}');
      });
    }

    api('PUT', `organisation/${rootState.organisation.currentOrganisation.id}/business/${payload.merchant_id}/instant-replies/${payload.reply_id}`, payload.data, null, 'w')
      .then((response) => {
        if (response.status === 200) {
          commit('INSTANT_REPLY_SAVED', {
            reply_id: payload.reply_id,
            // message_ids: response.data.message_ids,
            // uploaded_files: response.data.uploaded_files,
            messages: response.data.instant_reply.messages,
          });
        }
      })
      .catch((error) => {
        commit('API_ERROR', {
          error: error.response,
          reply_id: payload.reply_id,
        });
      });
  },
  updateReplyStatus({ rootState }, payload) {
    api('PUT', `organisation/${rootState.organisation.currentOrganisation.id}/business/${payload.businessId}/instant-replies/${payload.replyId}`, payload.data, null, 'w')
      .catch(() => {
        // TODO add error handling
      });
  },
  deleteInstantReply({ commit, rootState }, payload) {
    commit('INSTANT_REPLY_DELETED', false);
    api('DELETE', `organisation/${rootState.organisation.currentOrganisation.id}/business/${payload.merchant_id}/instant-replies/${payload.reply_id}`, null, null, 'w')
      .then((response) => {
        if (response.status === 200) {
          commit('INSTANT_REPLY_DELETED', payload.reply_id);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },
  deleteInstantReplyMessage({ commit, rootState }, payload) {
    commit('INSTANT_REPLY_MESSAGE_DELETED', false);
    const request = api('DELETE', `organisation/${rootState.organisation.currentOrganisation.id}/business/${payload.merchant_id}/instant-replies/${payload.reply_id}/messages/${payload.message_id}`, payload.data, null, 'w');
    request.then((response) => {
      if (response.status === 200) {
        commit('INSTANT_REPLY_MESSAGE_DELETED', payload.message_id);
      }
    }).catch((error) => {
      commit('API_ERROR', error.response);
    });

    return request;
  },
  fetchKeywordAnalytics({ commit }, payload) {
    api('GET', `/merchants/${payload.merchant_id}/instant-replies/${payload.reply_id}/analytics`, payload.data)
      .then((response) => {
        if (response.status === 200) {
          commit('SET_KEYWORD_ANALYTICS', response.data);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },

  fetchAutomationRules({ commit }, payload) {
    commit('START_LOADING_RULES');
    api('GET', `/merchants/${payload.merchant_id}/automation-rules`, payload.data)
      .then((response) => {
        if (response.status === 200) {
          commit('SET_RULE_LIST', response.data);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },
  createAutomationRule({ commit }, payload) {
    commit('AUTOMATION_RULE_SAVED', false);
    api('POST', `/merchants/${payload.merchant_id}/automation-rules`, payload.data)
      .then((response) => {
        if (response.status === 200) {
          commit('AUTOMATION_RULE_SAVED', true);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },
  updateAutomationRule({ commit }, payload) {
    commit('AUTOMATION_RULE_SAVED', false);
    api('PUT', `/merchants/${payload.merchant_id}/automation-rules/${payload.rule_id}`, payload.data)
      .then((response) => {
        if (response.status === 200) {
          commit('AUTOMATION_RULE_SAVED', true);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },
  deleteAutomationRule({ commit }, payload) {
    commit('AUTOMATION_RULE_DELETED', false);
    api('DELETE', `/merchants/${payload.merchant_id}/automation-rules/${payload.rule_id}`)
      .then((response) => {
        if (response.status === 200) {
          commit('AUTOMATION_RULE_DELETED', true);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },

  fetchSettings({ commit, rootState }, merchantId) {
    const request = api('GET', `/organisation/${rootState.organisation.currentOrganisation.id}/business/${merchantId}/instant-replies/settings`, null, null, 'w');
    request
      .then((response) => {
        if (response.status === 200) {
          commit('SET_AUTOMATION_SETTINGS', response.data);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
    return request;
  },
  updateSettings({ commit, rootState }, payload) {
    commit('AUTOMATION_SETTINGS_SAVED', false);
    const request = api('PUT', `/organisation/${rootState.organisation.currentOrganisation.id}/business/${payload.merchant_id}/instant-replies/settings`, payload.data, null, 'w');
    request
      .then((response) => {
        if (response.status === 200) {
          commit('AUTOMATION_SETTINGS_SAVED', payload.merchant_id);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
    return request;
  },
  updateUnsubscribeMessage({ commit, rootState }, payload) {
    commit('UNSUBSCRIBE_MESSAGE_SAVED', false);
    api('PUT', `/organisation/${rootState.organisation.currentOrganisation.id}/business/${payload.merchant_id}/instant-replies/unsubscribe-message`, payload.data, null, 'w')
      .then((response) => {
        if (response.status === 200) {
          commit('UNSUBSCRIBE_MESSAGE_SAVED', payload.merchant_id);
          commit('UPDATE_UNSUBSCRIBED_MESSAGE', payload.data.unsubscribe_message);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error);
      });
  },

  /**
   * Uploads a file to server and returns url and mime type.
   * @param {Object} payload
   * @param {FormData} payload.data - formData with file key
   * @param {String} payload.businessId - number id
   * @returns hash_name, mime_type, original_name, temp, url
   */
  uploadTempFile({ commit, rootState }, payload) {
    commit('FILE_UPLOADED', false);
    const request = api('POST', `organisation/${rootState.organisation.currentOrganisation.id}/business/${payload.businessId}/instant-replies/upload`, payload.data, {
      'Content-Type': 'multipart/form-data',
    }, 'w');
    request
      .then((response) => {
        if (response.status === 200) {
          commit('FILE_UPLOADED', {
            message_id: payload.message_id,
            file: response.data,
          });
        }
      })
      .catch((error) => {
        const errorData = error.response ? error.response : {
          status: 413,
          message: 'Request Entity too large.',
        };
        commit('FILE_UPLOAD_ERROR', {
          sid: payload.data.get('temp_sid'),
          error: errorData,
        });
      });
    return request;
  },
  updateInProgress({ commit }, payload) {
    commit('UPDATE_IN_PROGRESS', payload);
  },
  clearBackgroundActions({ commit }) {
    commit('CLEAR_BACKGROUND_ACTIONS');
  },
  addBackgroundActions({ commit }, payload) {
    commit('ADD_BACKGROUND_ACTIONS', payload);
  },
  /**
   * Actions are removed by id. Method accepts id to remove or assistantId and action values and finds an id to remove.
   * @param {Object} payload Object with action parameters.
   * @param {string} [payload.id] Id of the action to remove. Can be provided alone.
   * @param {string} [payload.assistantId] Assistant id of the action to remove. Must be provided with the action parameter.
   * @param {string} [payload.action] Action type to remove. Must be provided with the assistantId parameter.
   */
  removeBackgroundAction({ commit, state }, payload) {
    if (payload && payload.id) {
      commit('REMOVE_BACKGROUND_ACTION', payload.id);
    } else if (payload && payload.assistantId && payload.action) {
      const targetAction = state.backgroundActions.find(
        ba => (
          ba.action === payload.action &&
          ba.assistantId === payload.assistantId &&
          ba.type === payload.type
        ),
      );
      if (targetAction && targetAction.id) {
        commit('REMOVE_BACKGROUND_ACTION', targetAction.id);
      }
    }
  },
  backgroundActionStatusChange({ commit }, payload) {
    commit('UPDATE_BACKGROUND_ACTION', { assistantId: payload.assistantId, action: payload.action, type: payload.type, data: { status: payload.status, finished: payload.finished } });
  },
  cancelFileUpload({ commit }, status = true) {
    commit('FILE_UPLOAD_CANCELLED', status);
  },
  updateFileChangeCounter({ commit }, payload) {
    commit('UPDATE_FILE_CHANGE_COUNTER', payload);
  },
  clearFileChangeCounter({ commit }) {
    commit('CLEAR_FILE_CHANGE_COUNTER');
  },
  removeBackgroundAiFiles({ commit, rootState }, payload) {
    const removeFile = (fileUid) => {
      const endpoint = `organisation/${rootState.organisation.currentOrganisation.id}/assistant/${payload.assistantId}/file/${fileUid}/delete/${payload.fileDeleteGroupId}`;
      return api(
        'DELETE',
        endpoint,
        null,
        null,
        'w',
      );
    };

    let fileIndex = 0;
    const maxRetries = 10;
    let currentRetry = 0;
    const results = {
      removed: [],
      failedToRemove: [],
    };
    const processRemove = (fIndex) => {
      if (rootState.automation.fileUploadCancelled) {
        commit('REMOVE_BACKGROUND_ACTION', payload.id);
        return;
      }
      if (fIndex === payload.files.length) {
        // let message = 'File deletion has been successfully completed.';
        // let variant = 'OK';
        // if (results.failedToRemove && results.failedToRemove.length) {
        //   message = 'Some files couldn\'t be deleted.';
        //   variant = 'error';
        // }
        // if (results.removed && results.removed.length === 0) {
        //   message = 'File deletion failed.';
        //   variant = 'error';
        // }
        // window.eventBus.$emit('show-toast', { message, variant });
        window.eventBus.$emit('files-removed', {
          assistantId: payload.assistantId,
          results,
        });
        commit('REMOVE_BACKGROUND_ACTION', payload.id);
        return;
      }
      removeFile(payload.files[fIndex])
        .then((response) => {
          if (response.status === 200) {
            // SUCCESS
            currentRetry = 0;
            fileIndex++;
            results.removed.push(payload.files[fIndex]);
          } else if ([422, 504].includes(response.status)) {
            // FAILED
            if (currentRetry < maxRetries) {
              currentRetry++;
            } else {
              currentRetry = 0;
              fileIndex++;
              results.failedToRemove.push(payload.files[fIndex]);
            }
          } else {
            // FAILED with any other status - do not retry
            currentRetry = 0;
            fileIndex++;
            results.failedToRemove.push(payload.files[fIndex]);
          }
          processRemove(fileIndex);
        })
        .catch((error) => {
          if ([422, 504].includes(error.response && error.response.status)) {
            // FAILED
            if (currentRetry < maxRetries) {
              currentRetry++;
            } else {
              currentRetry = 0;
              fileIndex++;
              results.failedToRemove.push(payload.files[fIndex]);
            }
          } else {
            // FAILED with any other status - do not retry
            currentRetry = 0;
            fileIndex++;
            results.failedToRemove.push(payload.files[fIndex]);
          }
          processRemove(fileIndex);
        });
    };
    if (payload && payload.files && payload.files.length) {
      // Start deleting the first file. The rest will be deleted from the callback.
      processRemove(fileIndex);
    } else {
      commit('REMOVE_BACKGROUND_ACTION', payload.id);
    }
  },
  resetTempFileCounter({ commit }, aiAssistantUid) {
    commit('RESET_TEMP_FILE_COUNTER', aiAssistantUid);
  },
  updateFileDeleteCounter({ commit }, payload) {
    commit('UPDATE_FILE_DELETE_COUNTER', payload);
  },
  updateFileUploadCounter({ commit }, payload) {
    commit('UPDATE_FILE_UPLOAD_COUNTER', payload);
  },
  uploadBackgroundAiFiles({ commit, rootState }, payload) {
    commit('UPDATE_BACKGROUND_ACTION', {
      id: payload.id,
      assistantId: payload.assistantId,
      action: 'uploadAiFiles',
      data: { status: StatusTypes.RUNNING },
    });
    const uploadFile = (file) => {
      // DUMMY UPLOAD FUNCTION for testing
      // return new Promise((resolve, reject) => {
      //   setTimeout(() => {
      //     const randomIndex = Math.floor(Math.random() * 3);
      //     const randomStatus = [200, 422, 504];
      //     resolve({ status: randomStatus[randomIndex] });
      //   }, 5000);
      // });

      // REAL UPLOAD FUNCTION
      const formData = new FormData();
      formData.append('file', file);
      const uploadEndpoint = `organisation/${rootState.organisation.currentOrganisation.id}/assistant/${payload.assistantId}/file/upload/${payload.fileUploadGroupId}`;

      return api(
        'POST',
        uploadEndpoint,
        formData,
        {
          'Content-Type': 'multipart/form-data',
        },
        'w',
      );
    };
    let fileIndex = 0;
    const maxRetries = 10;
    let currentRetry = 0;
    const results = {
      success: [],
      failed: [],
    };
    const processUpload = (fIndex) => {
      // check if it is canceled
      if (rootState.automation.fileUploadCancelled) {
        commit('REMOVE_BACKGROUND_ACTION', payload.id);
        return;
      }
      if (fIndex === payload.files.length) {
        commit('UPDATE_BACKGROUND_ACTION', {
          id: payload.id,
          assistantId: payload.assistantId,
          action: 'uploadAiFiles',
          data: { status: StatusTypes.COMPLETED, results },
        });
        // let message = 'File upload has been successfully completed.';
        // let variant = 'OK';
        // if (results.failed.length) {
        //   message = 'Some files couldn\'t be uploaded.';
        //   variant = 'error';
        // }
        // if (results.success.length === 0) {
        //   message = 'File upload failed.';
        //   variant = 'error';
        // }
        // window.eventBus.$emit('show-toast', { message, variant });

        commit('REMOVE_BACKGROUND_ACTION', payload.id);
        return;
      }
      uploadFile(payload.files[fIndex])
        .then((response) => {
          if (response.status === 200) {
            // SUCCESS
            currentRetry = 0;
            fileIndex++;
            results.success.push(payload.files[fIndex]);
          } else if ([422, 504].includes(response.status)) {
            // FAILED
            if (currentRetry < maxRetries) {
              currentRetry++;
            } else {
              currentRetry = 0;
              fileIndex++;
              results.failed.push(payload.files[fIndex]);
            }
          } else {
            // FAILED with any other status - do not retry
            currentRetry = 0;
            fileIndex++;
            results.failed.push(payload.files[fIndex]);
          }
          commit('UPDATE_BACKGROUND_ACTION', {
            id: payload.id,
            assistantId: payload.assistantId,
            action: 'uploadAiFiles',
            data: { results },
          });
          processUpload(fileIndex);
        })
        .catch((error) => {
          if ([422, 504].includes(error.response && error.response.status)) {
            // FAILED
            if (currentRetry < maxRetries) {
              currentRetry++;
            } else {
              currentRetry = 0;
              fileIndex++;
              results.failed.push(payload.files[fIndex]);
            }
          } else {
            // FAILED with any other status - do not retry
            currentRetry = 0;
            fileIndex++;
            results.failed.push(payload.files[fIndex]);
          }
          commit('UPDATE_BACKGROUND_ACTION', {
            id: payload.id,
            assistantId: payload.assistantId,
            action: 'uploadAiFiles',
            data: { results },
          });
          processUpload(fileIndex);
        });
    };
    if (payload && payload.files && payload.files.length) {
      // Start uploading the first file. The rest will be uploaded in the callback.
      processUpload(fileIndex);
    } else {
      commit('REMOVE_BACKGROUND_ACTION', payload.id);
    }
  },
  removeBackgroundActionStartedByUser({ commit }, payload) {
    commit('REMOVE_BACKGROUND_ACTION_STARTED_BY_USER', payload);
  },
  setNewSchemaValues({ commit }, payload) {
    commit('SET_NEW_SCHEMA_VALUES', payload);
  },
  clearNewSchemaValues({ commit }) {
    commit('SET_NEW_SCHEMA_VALUES', null);
  },
  assistantDataSaved({ commit }, payload) {
    commit('ASSISTANT_DATA_SAVED', payload);
  },
  setScrapingStatus({ commit }, payload) {
    commit('SET_SCRAPING_STATUS', payload);
  },
  removeAllCounters({ commit }) {
    commit('REMOVE_ALL_COUNTERS');
  },
  updateCounter({ commit }, payload) {
    commit('UPDATE_COUNTER', payload);
  },
  removeCounter({ commit }, payload) {
    commit('REMOVE_COUNTER', payload);
  },
  updateDeleteCounter({ commit }, payload) {
    commit('UPDATE_DELETE_COUNTER', payload);
  },
  removeDeleteCounter({ commit }, payload) {
    commit('REMOVE_DELETE_COUNTER', payload);
  },
};
